import { get } from "./axios";

export function getAccessToken(data){
  return get(`/open/ys/getAccessToken`,data);
}

export function getLiveUrl(deviceSerial,protocol,data){
  return get(`/open/ys/getLiveUrl/${deviceSerial}/${protocol}`,data)
}



// WEBPACK FOOTER //
// ./src/api/OtherService.js